import { action } from 'satcheljs';
import AttachmentId from 'owa-service/lib/contract/AttachmentId';

export const prefetchAllWacResources = action('PREFETCH_ALL_WAC_RESOURCES');

export const prefetchWacResourcesForAttachments = action(
    'PREFETCH_WAC_RESOURCES_ATTACHMENTS',
    (attachmentIds: AttachmentId[]) => ({ attachmentIds })
);

export const prefetchWacResourcesForFiles = action(
    'PREFETCH_WAC_RESOURCES_FILES',
    (fileNames: string[]) => ({ fileNames })
);
